// src/utils/logUserAction.js
import axios from 'axios';

export const logUserAction = async (username, module, action, parameters = {}, additionalInfo = "") => {
  try {
    const logData = {
      username,
      module,
      action,
      parameters,
      additional_info: additionalInfo,
    };

    // Make sure the URL points to the correct backend server (including protocol and port)
    await axios.post('api/logs/', logData); // Ensure the trailing slash is included
  } catch (error) {
    console.error('Error logging user action:', error);
  }
};
